/**
 * Helper function to get the correct image URL
 * Handles both localhost (development) and production URLs
 * 
 * @param {string} imagePath - The image path from database
 * @param {string} placeholder - Fallback placeholder URL
 * @returns {string} - Full image URL
 */
export const getImageUrl = (imagePath, placeholder = '/assets/branding/thumbnail.png') => {
  if (!imagePath) return placeholder;
  
  // If it's already a full URL
  if (imagePath.startsWith('http')) {
    // Replace localhost URL with production domain
    if (imagePath.includes('127.0.0.1:8000')) {
      return imagePath.replace('http://127.0.0.1:8000', '');
    }
    return imagePath;
  }
  
  // If it's a relative path starting with storage/
  if (imagePath.startsWith('storage/')) {
    return `/${imagePath}`;
  }
  
  // Default: prepend /storage/
  return `/storage/${imagePath}`;
};
